import api from "@api";
import { components } from "@api/schema";
import { ID } from "@types";

export const API_PATH = "service_providers";
export const API_PROVIDER_SERVICES_COUNT = "services_count";
export const API_PATH_METRICS = "service_provider_metrics";
export const API_PATH_REPEAT_RATE = "repeat_rate";
export const API_PATH_REALISATION_RATE = "realisation_rate";

export type IServiceProvider = components["schemas"]["serviceProvider"];

export type IProviderServicesCount =
  components["schemas"]["serviceProviderServicesCount"];

export type IServiceProviderMetrics =
  components["schemas"]["serviceProviderMetrics"];

export type IServiceProviderRepeatRateMetrics =
  components["schemas"]["serviceProviderRepeatRateMetric"];

export type IServiceProviderRealisationRateMetrics =
  components["schemas"]["serviceProviderRealisationRateMetric"];
export interface IGetServiceProviderOptions {
  includes?: "user"[];
}

export const getServiceProvider = async (
  id: ID,
  options?: IGetServiceProviderOptions
) => {
  return await api.get<IGetServiceProviderOptions, IServiceProvider>(
    [API_PATH, String(id)].join("/"),
    options
  );
};

export const getProviderServicesCount = async (
  id: ID,
  options?: IGetServiceProviderOptions
) => {
  return await api.get<IGetServiceProviderOptions, IProviderServicesCount>(
    [API_PATH, String(id), API_PROVIDER_SERVICES_COUNT].join("/"),
    options
  );
};

export const getServiceProviderMetrics = (
  id: ID,
  options?: IGetServiceProviderOptions
) => {
  return api.get<IGetServiceProviderOptions, IServiceProviderMetrics>(
    [API_PATH_METRICS, String(id)].join("/"),
    options
  );
};

export const getRepeatRateMetrics = (
  id: ID,
  options?: IGetServiceProviderOptions
) => {
  return api.get<IGetServiceProviderOptions, IServiceProviderRepeatRateMetrics>(
    [API_PATH_METRICS, String(id), API_PATH_REPEAT_RATE].join("/"),
    options
  );
};

export const getRealisationRateMetrics = (
  id: ID,
  options?: IGetServiceProviderOptions
) => {
  return api.get<
    IGetServiceProviderOptions,
    IServiceProviderRealisationRateMetrics
  >(
    [API_PATH_METRICS, String(id), API_PATH_REALISATION_RATE].join("/"),
    options
  );
};
